import type {
    SICCode,
    SICCodeCategoryLookup,
    SICCodeCategoryWithSICArray,
    SICCodeLookup
} from '@types';

import customerDataRequest, {
    customerDataMicroserviceRequest
} from './api/customer-data';

export const getSICCodes = async (): Promise<SICCode[]> => {
    const {
        data: {
            data: SICCodesData
        }
    } = await customerDataRequest<SICCode[]>('get', '/sponsors/sic-codes');

    if (!SICCodesData) { return []; }

    return SICCodesData;
};

export const buildSICCodesLookupIndex = (sicCodes: SICCode[]): Record<number, SICCodeLookup> | null => {
    if (!sicCodes) { return null; }

    const SICCodesLookupIndex: Record<number, SICCodeLookup> = {};

    sicCodes.forEach((sicCode) => {
        SICCodesLookupIndex[sicCode.code] = {
            icon: sicCode.icon,
            name: sicCode.name
        };
    });

    return SICCodesLookupIndex;
};

export const getSICCodeCategories = async (): Promise<SICCodeCategoryWithSICArray[]> => {
    try {
        const {
            data: sicCodeCategories
        } = await customerDataMicroserviceRequest<SICCodeCategoryWithSICArray[]>(
            'get',
            process.env.SPONSOR_MANAGEMENT_API_URL,
            '/sponsors/sic-code-categories'
        );

        if (!sicCodeCategories) { return []; }

        return sicCodeCategories;
    } catch {
        return [];
    }
};

export const buildSICCodeCategoriesLookupIndex = (
    SICCodeCategories: SICCodeCategoryWithSICArray[]
): Record<number, SICCodeCategoryLookup> | null => {
    if (!SICCodeCategories) { return null; }

    const parentCategoryLookupIndex: Record<number, SICCodeCategoryLookup> = {};

    SICCodeCategories.forEach((category) => {
        parentCategoryLookupIndex[category.id] = {
            icon: category.icon,
            name: category.name,
            sicCodes: category.sicCodes
        };
    });

    return parentCategoryLookupIndex;
};

export const getKeywordSICCodes = async (keyword: string): Promise<string[]> => {
    if (!keyword.trim().length) { return []; }

    try {
        const encodedKeyword = encodeURIComponent(keyword);

        const {
            data: keywordSICCodes
        } = await customerDataMicroserviceRequest<string[]>(
            'get',
            process.env.SPONSOR_MANAGEMENT_API_URL,
            `/sponsors/sic-codes/${encodedKeyword}`
        );

        if (!keywordSICCodes) { return []; }

        return keywordSICCodes;
    } catch {
        return [];
    }
};
